import trashTokens from "@amzn/meridian-tokens/base/icon/trash";
import undoTokens from "@amzn/meridian-tokens/base/icon/undo";
import IconButton from "./IconButton";
import { deleteButtonTheme } from "./insights.constants";

/**
 * DeleteConfirmButtons - confirm/cancel pair for a row's delete-confirmation state, shared by
 * Agenda and Action Items so the icons, destructive theming, and aria labels stay in step.
 *
 * Deliberately renders ONLY the two buttons (a fragment) and not a wrapping Row: the two call
 * sites lay them out differently — Agenda pins them in a right-aligned fixed-height Row, Action
 * Items passes them as the second and third slots of `actionRowLayout`'s widths array — so each
 * site keeps its own container. Safe for the widths case because Meridian's Row maps widths with
 * CSS `& > *:nth-child(N)` against DOM children, and a fragment adds no DOM node, so both buttons
 * still occupy their own slots.
 */
const DeleteConfirmButtons = ({ onConfirm, onCancel }) => (
  <>
    <IconButton icon={trashTokens} onClick={onConfirm} ariaLabel="Confirm delete" tokens={deleteButtonTheme} />
    <IconButton icon={undoTokens} onClick={onCancel} ariaLabel="Cancel delete" />
  </>
);

export default DeleteConfirmButtons;
